<template>
  <section class="ticket-group">
    <ul class="voucher-list">
      <template v-for="products in groupInfo.products">
        <li
          v-for="(voucher, idx) in products.concurrency"
          :key="`product__${idx}`"
        >
          <VoucherItemIndividual
            :key="`${productType}__${idx}__item`"
            :voucher="voucher"
            :voucher-type="productType"
            :selected-product-id="selectedVoucher?.productid"
            @on-click-purchase="voucherPurchase(voucher, $event, productType)"
          />
          <div v-if="productType === 'package'" class="product-package">
            <ul>
              <li
                v-for="(packageItem, index) in packageList"
                :key="'package_detail_' + index"
              >
                <div class="picture-area">
                  <WebpImage
                    :image-info="{
                      imageUrl: getValue(packageItem, 'image'),
                      width: 104,
                      height: 156,
                      alt: getValue(packageItem, 'title'),
                    }"
                  />
                </div>
                <span class="product-package-title">
                  <span>{{ getValue(packageItem, 'title') }}</span>
                </span>
              </li>
            </ul>
          </div>
        </li>
      </template>
    </ul>
  </section>
</template>

<script>
  import { filter, get } from 'lodash'
  import WebpImage from '@/components/image/WebpImage'
  import VoucherItemIndividual from '@/components/lnb/voucher/ui/VoucherItemIndividual.vue'
  export default {
    name: 'PopupVoucherGroups',
    components: {
      VoucherItemIndividual,
      WebpImage,
    },
    props: {
      groupInfo: {
        type: Object,
      },
      productType: {
        type: String,
      },
      packageDetailList: {
        type: Array,
      },
      purchaseFn: {
        type: Function,
      },
      categoryIndex: {
        type: Number,
      },
    },
    data() {
      return {
        tooltipToggle: false,
        selectedVoucher: '',
      }
    },
    computed: {
      packageList() {
        const productId = get(
          this.groupInfo,
          'products.0.concurrency.0.productid',
          '',
        )
        return get(
          filter(
            this.packageDetailList,
            (item) => item.productId === productId,
          ),
          '0.list',
          [],
        )
      },
    },
    methods: {
      setNumberCommas(data) {
        if (!data) return 0
        return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      },
      getValue(item, key) {
        return get(item, [key], '')
      },
      voucherPurchase(voucher, productId, productType) {
        this.selectedVoucher = Object.assign(voucher, { productid: productId })
        this.purchaseFn(this.selectedVoucher, this.categoryIndex, productType)
      },
    },
  }
</script>
<style scoped>
  .voucher-list {
    padding-bottom: 12px;
  }
</style>
